<div class="wrapper border rounded-[5px] p-[15px]">
  @if (data?.status === 'passed' || data?.status === 'failed') {
    <div class="row flex flex-col mb-[20px]">
      <div class="label">
        Test Result:
      </div>
      <div class="result-display flex flex-row items-center gap-[8px]">
        @if (data?.status === 'passed') {
          <mat-icon svgIcon="green-check" class="result-icon"></mat-icon>
          <span class="result-text text-type-10">Passed</span>
        } @else {
          <mat-icon svgIcon="failed-orange" class="result-icon"></mat-icon>
          <span class="result-text text-type-10">Failed</span>
        }
      </div>
    </div>
    @if (data?.status === 'failed') {
      <div class="row flex flex-col mb-[20px]">
        <div class="label">
          Note:
        </div>
        <div class="value">
          {{ data?.failed_reason }}
        </div>
      </div>
    }
  } @else {
    <div class="toggle-section mb-[30px]">
      <app-toggle-buttons
        [buttonLabels]="['Passed', 'Failed']"
        [parentFormGroup]="form"
        controlName="result"
        heading="Test result *"
      ></app-toggle-buttons>
    </div>
    @if (form?.controls?.['result']?.value === 'Failed') {
      <app-text-area
        (checkForErrors)="checkForErrors($event)"
        [controlName]="'comment'"
        [error]="errorMessages['comment']"
        [label]="'Note'"
        [parentFormGroup]="form"
        class="mb-[20px]"
        />
    }
    <div class="action-section mb-[20px]">
      <app-primary-button
        (handleClick)="save()"
        [isDisabled]="form.invalid"
        >
        Save
      </app-primary-button>
    </div>
  }

</div>
